(function () {
  var secs = [].slice.call(document.querySelectorAll('.lg-body > section[id]'));
  var links = [].slice.call(document.querySelectorAll('.lg-toc a[href^="#"]'));
  function mark(id) {
    links.forEach(function (a) {
      if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'location');
      else a.removeAttribute('aria-current');
    });
  }
  if (secs.length && links.length) {
    mark(secs[0].id);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) mark(e.target.id); });
      }, { rootMargin: '-18% 0px -72% 0px' });
      secs.forEach(function (s) { io.observe(s); });
    }
  }
  var m = document.querySelector('.lg-tocm');
  if (m) m.addEventListener('click', function (e) { if (e.target.closest('a')) m.open = false; });
})();

(function () {
  var sections = [].slice.call(document.querySelectorAll('.lg-body > section[id]'));
  if (!sections.length || sections[0].querySelector('.lg-section')) return;
  var mobile = window.matchMedia('(max-width:600px)');
  var screenMobile = mobile.matches;
  var printMedia = window.matchMedia('print');
  var disclosures = [];
  sections.forEach(function (section) {
    var heading = section.querySelector('.lg-hd');
    var title = heading && heading.querySelector('h2');
    if (!title) return;
    var details = document.createElement('details');
    details.className = 'lg-section';
    var summary = document.createElement('summary');
    summary.className = 'lg-section__summary';
    var anchor = heading.querySelector('.lg-anchor');
    summary.appendChild(title);
    var body = document.createElement('div');
    body.className = 'lg-section__body';
    // Move the original nodes; never copy, rewrite or regenerate legal text.
    heading.remove();
    while (section.firstChild) body.appendChild(section.firstChild);
    details.appendChild(summary);
    details.appendChild(body);
    details.open = !mobile.matches;
    section.appendChild(details);
    if (anchor) section.insertBefore(anchor, details);
    disclosures.push(details);
  });
  document.documentElement.classList.add('lg-enhanced');
  function revealHash(scroll) {
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return; }
    var target = id && document.getElementById(id);
    if (!target) return;
    disclosures.forEach(function (details) {
      if (details.contains(target) || details.parentElement === target) details.open = true;
    });
    if (scroll) requestAnimationFrame(function () { target.scrollIntoView({block:'start'}); });
  }
  function resize() {
    // Printing can temporarily change the layout viewport breakpoint.
    if (printMedia.matches || printState || mobile.matches === screenMobile) return;
    screenMobile = mobile.matches;
    disclosures.forEach(function (details) { details.open = !mobile.matches; });
    revealHash(false);
  }
  if (mobile.addEventListener) mobile.addEventListener('change', resize);
  else mobile.addListener(resize);
  window.addEventListener('hashchange', function () { revealHash(true); });
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;
    // Also handles a second click on a link whose hash is already current.
    var id;
    try { id = decodeURIComponent(link.getAttribute('href').slice(1)); } catch (e) { return; }
    var target = document.getElementById(id);
    if (target) disclosures.forEach(function (details) {
      if (details.contains(target) || details.parentElement === target) details.open = true;
    });
  });
  var printState;
  window.addEventListener('beforeprint', function () {
    if (printState) return;
    printState = disclosures.map(function (details) { return details.open; });
    disclosures.forEach(function (details) { details.open = true; });
  });
  window.addEventListener('afterprint', function () {
    if (!printState) return;
    disclosures.forEach(function (details, i) { details.open = printState[i]; });
    printState = null;
  });
  revealHash(true);
})();
